import { gql } from '@ori/fetching';

export const beautyStoreQuery = gql`
  query beautyStore($name: ID, $productListType: ProductListType!) {
    application {
      personalProductListConfiguration {
        isPplEnabled
        addThis {
          sharedUrl
        }
      }
    }
    beautyStore(name: $name) {
      profile {
        name
        firstName
        lastName
        photoUrl
        contacts {
          type
          value
        }
        referralProgram {
          title
          greetingMessage
          message
          benefitsLink {
            relativeUrl
            title
          }
          allowedContacts
        }
      }
      productLists(productListType: $productListType) {
        productListId
        items {
          itemCode
        }
      }
    }
  }
`;
